import api from "../../services/api.js";
import { useEffect, useState } from "react";
import "../franquias-instagram-geral/franquias-instagram-geral.css"
import DataTable from "react-data-table-component";
import GraficoResumo from "../../components/grafico-resumo/grafico-resumo.jsx";

import { Link } from "react-router-dom";



function FranquiasInstagramGeral() {

    const [dados, setDados] = useState([]);
    const [id_franquia, setId_franquia] = useState(0);
    const [nome_franquia, setNome_franquia] = useState("");
    const [usuario, setUsuario] = useState("");
    const [id_metrics, setId_metrics] = useState(0)
    const [seguidores, setSeguidores] = useState(0);
    const [seguindo, setSeguindo] = useState(0)
    const [alcance_organico, setAlcance_organico] = useState(0);
    const [reels, setReels] = useState(0);
    const [postagens, setPostagens] = useState(0);
    const [stories, setStories] = useState(0);
    const [visualizacoes, setVisualizacoes] = useState(0);
    const [curtidas, setCurtidas] = useState(0);
    const [comentarios, setComentarios] = useState(0);
    const [compartilhamentos, seCompartilhamentos] = useState(0);
    const [salvamentos, setSalvamentos] = useState(0);
    const [observacoes, setObservacoes] = useState("");
    const [controla_edit, setControlaEdit] = useState(true);

    const [aberto, setAberto] = useState(false);

    const [larguraTela, setLarguraTela] = useState(window.innerWidth);
    const ehMobile = larguraTela < 1100;


    const hoje = new Date().toLocaleDateString("en-CA"); // aaaa-mm-dd
    const [data_input, setData_input] = useState(hoje);
    const [data_registro, setData_registro] = useState(new Date().toLocaleDateString("pt-BR")); // dd/mm/aaaa


    const [mensagem, setMensagem] = useState({ texto: "", tipo: "" });

    const [mesFiltro, setMesFiltro] = useState("");
    const [resumo, setResumo] = useState([]);
    const [modalResumo, setModalResumo] = useState(false);


    // Handle window resize
    useEffect(() => {
        const handleResize = () => {
            setLarguraTela(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const columns = [
        {
            name: 'Código',
            selector: row => ("0000" + row.id_metrics).slice(-4),  //para colocar zero a esquerda
            sortable: true,
            width: "0%",
        },
        {
            name: 'Data',
            selector: row => row.data_registro,
            sortable: true,
            width: "7%",
            compact: true
        },
        {
            name: 'Franquia',
            selector: row => row.nome_franquia,
            sortable: true,
            width: "25%",
            compact: true
        },
        {
            name: 'Seguidores',
            selector: row => row.seguidores,
            sortable: true,
            width: "9%",
        },
        {
            name: 'Feed',
            selector: row => row.postagens,
            sortable: true,
            width: "8%",
            compact: true
        },
        {
            name: 'Reels',
            selector: row => row.reels,
            sortable: true,
            width: "6%",
            compact: true
        },
        {
            name: 'Stories',
            selector: row => row.stories,
            sortable: true,
            width: "6%",
            compact: true
        },
        {
            name: 'Visualizações',
            selector: row => row.visualizacoes,
            sortable: true,
            width: "8%",
            compact: true
        },
        {
            name: 'Curtidas',
            selector: row => row.curtidas,
            sortable: true,
            width: "6%",
            compact: true
        },

        {
            name: 'Status Atual',
            selector: row => row.status_atual,
            sortable: true,
            width: "7%",
            compact: true,
            cell: (row) => (
                <span className={`badge ${row.status_atual === 'Em dia' ? 'bg-success' :
                    row.status_atual === 'Atenção' ? 'bg-warning text-dark' :
                        row.status_atual === 'Irregular' ? 'bg-danger' : 'bg-secondary'
                    }`}>
                    {row.status_atual}
                </span>
            )
        },
        {
            name: 'Ação',
            center: true,
            cell: (row) => <>
                <button onClick={() => PesquisarMetricasEdit(row.id_metrics)} className="btn btn-info ms-3">
                    <i className="bi bi-eye"></i>
                </button>
            </>,
            width: "9%",
        }

    ];

    function calcularResumo(dados) {
        // Agrupa por mês (mm/aaaa)
        const porMes = {};
        dados.forEach((item) => {
            const mes = item.data_registro.substring(3, 10);
            if (!porMes[mes]) porMes[mes] = [];
            porMes[mes].push(item);
        });

        // Ordena os meses do mais antigo para o mais recente
        const mesesOrdenados = Object.keys(porMes).sort();

        // Pega os 3 meses mais recentes
        const ultimos3 = mesesOrdenados.slice(-3).reverse();

        return ultimos3.map((mes, index) => {
            const indexGlobal = mesesOrdenados.indexOf(mes);

            // Último registro do mês atual
            const registrosAtual = [...porMes[mes]].sort((a, b) =>
                a.data_registro.localeCompare(b.data_registro)
            );
            const ultimoAtual = registrosAtual[registrosAtual.length - 1];

            // Último registro do mês anterior (se existir)
            let base = null;
            if (indexGlobal > 0) {
                const mesAnterior = mesesOrdenados[indexGlobal - 1];
                const registrosAnterior = [...porMes[mesAnterior]].sort((a, b) =>
                    a.data_registro.localeCompare(b.data_registro)
                );
                base = registrosAnterior[registrosAnterior.length - 1];
            } else {
                // Se não tem mês anterior, usa o primeiro registro do próprio mês
                base = registrosAtual[0];
            }

            return {
                mes,
                seguidores: ultimoAtual.seguidores - base.seguidores,
                seguindo: ultimoAtual.seguindo - base.seguindo,
                alcance_organico: ultimoAtual.alcance_organico - base.alcance_organico,
                reels: ultimoAtual.reels - base.reels,
                postagens: ultimoAtual.postagens - base.postagens,
                stories: ultimoAtual.stories - base.stories,
                visualizacoes: ultimoAtual.visualizacoes - base.visualizacoes,
                curtidas: ultimoAtual.curtidas - base.curtidas,
                comentarios: ultimoAtual.comentarios - base.comentarios,
                compartilhamentos: ultimoAtual.compartilhamentos - base.compartilhamentos,
                salvamentos: ultimoAtual.salvamentos - base.salvamentos,
            };
        });
    }

    function PesquisarMetricasId() {
        let id_franquia = localStorage.getItem('id_franquia');
        api.get("/pesquisa_metricas_id", { params: { id_franquia } })
            .then((resp) => {
                //console.log(resp.data)

                // Agrupa por mês (aaaa-mm)
                const porMes = {};
                resp.data.forEach((item) => {
                    const mes = item.data_registro.substring(0, 7);
                    if (!porMes[mes]) porMes[mes] = [];
                    porMes[mes].push(item);
                });

                const dadosProcessados = resp.data.map((item) => {
                    const mes = item.data_registro.substring(0, 7);

                    const registrosOrdenados = [...porMes[mes]].sort((a, b) =>
                        a.data_registro.localeCompare(b.data_registro)
                    );

                    const primeiroId = registrosOrdenados[0].id_metrics;
                    const ultimoId = registrosOrdenados[registrosOrdenados.length - 1].id_metrics;

                    const ignorado = item.id_metrics !== primeiroId && item.id_metrics !== ultimoId;
                    // console.log(`id: ${item.id_metrics} | mês: ${mes} | primeiro: ${primeiroId} | último: ${ultimoId} | ignorado: ${ignorado}`);

                    const primeiroDoMes = registrosOrdenados[0].seguidores;
                    const ultimoDoMes = registrosOrdenados[registrosOrdenados.length - 1].seguidores;
                    const crescimentoMes = ultimoDoMes - primeiroDoMes;
                    const status_atual = crescimentoMes >= 20 ? "Em dia" :
                        crescimentoMes <= 0 ? "Irregular" :
                            "Atenção";


                    return {
                        ...item,
                        status_atual,
                        ignorado,
                        data_registro: item.data_registro.split("-").reverse().join("/")
                    };
                });

                setDados(dadosProcessados);
                setResumo(calcularResumo(dadosProcessados));
            })
            .catch((err) => {
                setDados([]);
                alert("Erro ao carregar dados");
            });
    }

    function PesquisarMetricasGeral() {
        api.get("/pesquisa_metricas_geral")
            .then((resp) => {

                // Agrupa por id_franquia
                const porFranquia = {};
                resp.data.forEach((item) => {
                    if (!porFranquia[item.id_franquia]) porFranquia[item.id_franquia] = [];
                    porFranquia[item.id_franquia].push(item);
                });

                // Para cada franquia pega apenas os registros do mês mais recente
                const registrosFiltrados = [];
                Object.keys(porFranquia).forEach((id_franquia) => {
                    const registros = porFranquia[id_franquia];

                    // Mês mais recente no formato aaaa-mm (substring 0,7)
                    const mesRecente = registros
                        .map(r => r.data_registro.substring(0, 7))
                        .sort()
                        .reverse()[0];

                    // Todos os registros do mês mais recente
                    const doMesRecente = registros.filter(r =>
                        r.data_registro.substring(0, 7) === mesRecente
                    );
                    registrosFiltrados.push(...doMesRecente);
                });

                // Agrupa por id_franquia + mês para calcular ignorado e status
                const porChave = {};
                registrosFiltrados.forEach((item) => {
                    const chave = `${item.id_franquia}_${item.data_registro.substring(0, 7)}`;
                    if (!porChave[chave]) porChave[chave] = [];
                    porChave[chave].push(item);
                });

                const dadosProcessados = registrosFiltrados.map((item) => {
                    const chave = `${item.id_franquia}_${item.data_registro.substring(0, 7)}`;

                    const registrosOrdenados = [...porChave[chave]].sort((a, b) =>
                        a.data_registro.localeCompare(b.data_registro)
                    );

                    const primeiroId = registrosOrdenados[0].id_metrics;
                    const ultimoId = registrosOrdenados[registrosOrdenados.length - 1].id_metrics;

                    const ignorado = item.id_metrics !== primeiroId && item.id_metrics !== ultimoId;

                    const primeiroDoMes = registrosOrdenados[0].seguidores;
                    const ultimoDoMes = registrosOrdenados[registrosOrdenados.length - 1].seguidores;
                    const crescimentoMes = ultimoDoMes - primeiroDoMes;
                    const status_atual = crescimentoMes >= 20 ? "Em dia" :
                        crescimentoMes <= 0 ? "Irregular" :
                            "Atenção";

                    return {
                        ...item,
                        status_atual,
                        ignorado,
                        data_registro: item.data_registro.split("-").reverse().join("/") // ← depois do spread
                    };
                });

                setDados(dadosProcessados);
                //console.log(dadosProcessados);
            })
            .catch((err) => {
                setDados([]);
                alert("Erro ao carregar dados");
            });
    }

    function PesquisarMetricasEdit(id) {//prencher os campos para editar
        setControlaEdit(true);
        setId_metrics(parseInt(id));
        let id_metrics = parseInt(id);
        api.get("/pesquisa_metricas_edit", { params: { id_metrics } })
            .then((resp) => {

                setData_input(resp.data[0].data_registro);
                setSeguidores(resp.data[0].seguidores);
                setSeguindo(resp.data[0].seguindo);
                setAlcance_organico(resp.data[0].alcance_organico);
                setReels(resp.data[0].reels);
                setPostagens(resp.data[0].postagens);
                setStories(resp.data[0].stories);
                setVisualizacoes(resp.data[0].visualizacoes);
                setCurtidas(resp.data[0].curtidas);
                setComentarios(resp.data[0].comentarios);
                seCompartilhamentos(resp.data[0].compartilhamentos);
                setSalvamentos(resp.data[0].salvamentos);
                setObservacoes(resp.data[0].observacoes);

                setAberto(true)
            })
            .catch((err) => {
                // setDados([]);
                alert("Erro ao carregar dados");
            });

    }

    function exibirMensagem(texto, tipo = "danger") {
        setMensagem({ texto, tipo });
        setTimeout(() => setMensagem({ texto: "", tipo: "" }), 3000);
    }

    function EditarMetricas() {

        if (!data_input) {
            exibirMensagem("Selecione uma data");
            return;
        }
        if (!seguidores || seguidores == 0) {
            exibirMensagem("Informe o número de seguidores");
            return;
        }
        if (!reels || reels == 0) {
            exibirMensagem("Informe o número de reels");
            return;
        }
        if (!postagens || postagens == 0) {
            exibirMensagem("Informe o número de postagens");
            return;
        }

        const params = {
            id_metrics: id_metrics,
            data_registro: data_input,
            seguidores: parseInt(seguidores),
            seguindo: parseInt(seguindo),
            alcance_organico: parseInt(alcance_organico),
            reels: parseInt(reels),
            postagens: parseInt(postagens),
            stories: parseInt(stories),
            visualizacoes: parseInt(visualizacoes),
            curtidas: parseInt(curtidas),
            comentarios: parseInt(comentarios),
            compartilhamentos: parseInt(compartilhamentos),
            salvamentos: parseInt(salvamentos),
            observacoes: observacoes
        };

        api.put(`/metricas_edit/${id_metrics}`, params)
            .then((resp) => {
                if (resp.status === 200) {
                    PesquisarMetricasId();
                    exibirMensagem("Registro alterado com sucesso!", "success");
                } else {
                    exibirMensagem("Erro ao alterar registro", "danger");
                }
            })
            .catch((err) => {
                exibirMensagem("Erro ao alterar registro", "danger");
            });
    }

    function AdicionarRegistro() {

        if (!data_input) {
            exibirMensagem("Selecione uma data");
            return;
        }
        if (!seguidores || seguidores == 0) {
            exibirMensagem("Informe o número de seguidores");
            return;
        }
        if (!reels || reels == 0) {
            exibirMensagem("Informe o número de reels");
            return;
        }
        if (!postagens || postagens == 0) {
            exibirMensagem("Informe o número de postagens");
            return;
        }

        const params = {
            id_franquia: parseInt(localStorage.getItem('id_franquia')),
            data_registro: data_input,
            seguidores: parseInt(seguidores),
            seguindo: parseInt(seguindo),
            alcance_organico: parseInt(alcance_organico),
            reels: parseInt(reels),
            postagens: parseInt(postagens),
            stories: parseInt(stories),
            visualizacoes: parseInt(visualizacoes),
            curtidas: parseInt(curtidas),
            comentarios: parseInt(comentarios),
            compartilhamentos: parseInt(compartilhamentos),
            salvamentos: parseInt(salvamentos),
            observacoes: observacoes
        };

        api.post("/metricas_inserir", params)
            .then((resp) => {
                if (resp.status === 201) {
                    PesquisarMetricasId();
                    exibirMensagem("Registro incluído com sucesso!", "success");
                } else {
                    exibirMensagem("Erro ao cadastrar registro", "danger");
                }
            })
            .catch((err) => {
                exibirMensagem("Erro ao cadastrar registro", "danger");
            });
    }

    useEffect(() => {
        PesquisarMetricasGeral();
    }, []);

    return <>
        {ehMobile ?
            <>

            </>
            :
            <>

                <div className="d-flex justify-content-center container-fundo-fran-cont ">
                    <div className="d-inline justify-content-center  container-body-fran-cont">

                        <div className="d-flex justify-content-between mt-2">
                            <div className=" col-6 ms-4 mb-2">
                                <input type="text" className="form-control" value={"Relação do ultimo mês de registro (Todas as Franquias)"} disabled={true} />
                            </div>

                            <div className="col-3 d-flex align-items-center gap-2 me-5">
                                <select
                                    className="form-select form-select-sm w-auto"
                                    value={mesFiltro}
                                    onChange={(e) => setMesFiltro(e.target.value)}
                                >
                                    <option value="">Todos os meses</option>
                                    {[...new Set(dados.map(d => d.data_registro.substring(3, 10)))]
                                        .sort()
                                        .reverse()
                                        .map(mes => (
                                            <option key={mes} value={mes}>{mes}</option>
                                        ))}
                                </select>
                                <button onClick={() => setModalResumo(true)} className="btn btn-info btn-sm" type="button">
                                    <i className="bi bi-bar-chart-fill me-1"></i> Resumo
                                </button>


                                <Link to="/franquias-instagram" className="btn btn-success btn-sm">
                                    <i className="bi bi-arrow-left-circle me-1"></i> Voltar
                                </Link>
                            </div>
                        </div>

                        <div className="col-12 bg-white p-2 rounded-4">
                            <DataTable
                                columns={columns}
                                data={mesFiltro ? dados.filter(d => d.data_registro.substring(3, 10) === mesFiltro) : dados}
                                conditionalRowStyles={[
                                    {
                                        when: (row) => row.ignorado,
                                        style: {
                                            textDecoration: "line-through",
                                            opacity: 0.4,
                                            fontStyle: "italic"
                                        }
                                    }
                                ]}
                                customStyles={{
                                    rows: {
                                        highlightOnHoverStyle: {
                                            backgroundColor: "#e8e8e8",
                                            borderBottomColor: "#ddd",
                                            transitionDuration: "0.2s",
                                        }
                                    }
                                }}
                                highlightOnHover
                                pagination={false}
                                noDataComponent={<p className="no-data-found">Nenhum registro encontrado</p>}
                            />
                        </div>
                    </div>


                </div >


                {/* Modal inicio */}
                {aberto && (
                    <div className="ig-overlay">
                        <div className="ig-modal-box">


                            {/* Header */}
                            <div className="ig-modal-header">
                                <div className="ig-modal-header-left">
                                    <div className="ig-icon"><i className="bi bi-instagram"></i></div>
                                    <span className="ig-modal-title">{nome_franquia}</span>
                                </div>
                                <div className="ig-modal-header-right">
                                    <input
                                        type="date"
                                        className="ig-select"
                                        value={data_input}
                                        onChange={(e) => {
                                            setData_input(e.target.value);
                                            const [ano, mes, dia] = e.target.value.split("-");
                                            setData_registro(`${dia}/${mes}/${ano}`);
                                        }}
                                    />

                                    <button className="ig-btn-x" onClick={() => setAberto(false)}>
                                        <i className="bi bi-x-lg"></i>
                                    </button>
                                </div>
                            </div>

                            {/* Audiência */}
                            <p className="ig-section-title">Audiência</p>
                            <hr className="ig-hr" />
                            <div className="ig-grid-3">
                                <div>
                                    <div className="ig-field-label"><i className="bi bi-people-fill"></i> Seguidores</div>
                                    <input type="text" className="form-control" onChange={(e) => setSeguidores(e.target.value)} value={seguidores} />
                                </div>
                                <div>
                                    <div className="ig-field-label"><i className="bi bi-person-plus"></i> Seguindo</div>
                                    <input type="text" className="form-control" onChange={(e) => setSeguindo(e.target.value)} value={seguindo} />
                                </div>
                                <div>
                                    <div className="ig-field-label"><i className="bi bi-broadcast"></i> Alcance Orgânico</div>
                                    <input type="text" className="form-control" onChange={(e) => setAlcance_organico(e.target.value)} value={alcance_organico} />
                                </div>
                            </div>
                            {mensagem.texto && (
                                <div className={`alert alert-${mensagem.tipo} py-2`} role="alert">
                                    {mensagem.tipo === "success"
                                        ? <i className="bi bi-check-circle-fill me-2"></i>
                                        : <i className="bi bi-exclamation-triangle-fill me-2"></i>}
                                    {mensagem.texto}
                                </div>
                            )}
                            {/* Conteúdo Publicado */}
                            <p className="ig-section-title">Conteúdo Publicado (Mês)</p>
                            <hr className="ig-hr" />
                            <div className="ig-grid-3">


                                <div>
                                    <div className="ig-field-label"><i className="bi bi-play-circle-fill"></i> Reels</div>
                                    <input type="text" className="form-control" onChange={(e) => setReels(e.target.value)} value={reels} />
                                </div>
                                <div>
                                    <div className="ig-field-label"><i className="bi bi-grid-fill"></i> Postagens</div>
                                    <input type="text" className="form-control" onChange={(e) => setPostagens(e.target.value)} value={postagens} />
                                </div>
                                <div>
                                    <div className="ig-field-label"><i className="bi bi-collection-fill"></i> Stories</div>
                                    <input type="text" className="form-control" onChange={(e) => setStories(e.target.value)} value={stories} />
                                </div>
                            </div>

                            {/* Engajamento */}
                            <p className="ig-section-title">Engajamento</p>
                            <hr className="ig-hr" />
                            <div className="ig-grid-3">
                                <div>
                                    <div className="ig-field-label"><i className="bi bi-eye-fill"></i> Visualizações</div>
                                    <input type="text" className="form-control" onChange={(e) => setVisualizacoes(e.target.value)} value={visualizacoes} />
                                </div>
                                <div>
                                    <div className="ig-field-label"><i className="bi bi-heart-fill"></i> Curtidas</div>
                                    <input type="text" className="form-control" onChange={(e) => setCurtidas(e.target.value)} value={curtidas} />
                                </div>
                                <div>
                                    <div className="ig-field-label"><i className="bi bi-chat-fill"></i> Comentários</div>
                                    <input type="text" className="form-control" onChange={(e) => setComentarios(e.target.value)} value={comentarios} />
                                </div>
                            </div>
                            <div className="ig-grid-2">
                                <div>
                                    <div className="ig-field-label"><i className="bi bi-share-fill"></i> Compartilhamentos</div>
                                    <input type="text" className="form-control" onChange={(e) => seCompartilhamentos(e.target.value)} value={compartilhamentos} />
                                </div>
                                <div>
                                    <div className="ig-field-label"><i className="bi bi-bookmark-fill"></i> Salvamentos</div>
                                    <input type="text" className="form-control" onChange={(e) => setSalvamentos(e.target.value)} value={salvamentos} />
                                </div>
                            </div>

                            {/* Observações */}
                            <p className="ig-obs-label">Observações:</p>
                            <textarea
                                className="ig-textarea"
                                placeholder="Anote aqui qualquer observação sobre esta franquia neste período..."
                                onChange={(e) => setObservacoes(e.target.value)}
                                value={observacoes}
                            />
                            {/* Footer */}
                            <div className="ig-modal-footer">
                                <button className="ig-btn-cancel" onClick={() => setAberto(false)}>Cancelar</button>

                            </div>
                        </div>
                    </div>
                )}
                {/* Modal Fim  */}

                {modalResumo && (
                    <div className="ig-overlay">
                        <div className="ig-modal-box" style={{ width: 1000 }}>

                            <div className="ig-modal-header">
                                <div className="ig-modal-header-left">
                                    <div className="ig-icon"><i className="bi bi-bar-chart-fill"></i></div>
                                    <span className="ig-modal-title">Resumo Geral — Último Mês por Franquia</span>
                                </div>
                                <button className="ig-btn-x" onClick={() => setModalResumo(false)}>
                                    <i className="bi bi-x-lg"></i>
                                </button>
                            </div>

                            <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
                                <table className="table table-bordered table-sm mt-2" style={{ fontSize: 11 }}>
                                    <thead style={{ backgroundColor: "#f5f5f5", color: "#666" }}>
                                        <tr>
                                            <th style={{ minWidth: 160 }}>Franquia</th>
                                            <th>Mês</th>
                                            <th>Seguidores.</th>
                                            <th>Seguindo.</th>
                                            <th>Reels</th>
                                            <th>Post.</th>
                                            <th>Stories</th>
                                            <th>Visual.</th>
                                            <th>Curtidas.</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ color: "#555", whiteSpace: "nowrap" }}>
                                        {(() => {
                                            const porFranquia = {};
                                            dados.forEach((item) => {
                                                if (!porFranquia[item.id_franquia]) porFranquia[item.id_franquia] = [];
                                                porFranquia[item.id_franquia].push(item);
                                            });

                                            return Object.keys(porFranquia)
                                                .map((id_franquia) => {
                                                    const registros = [...porFranquia[id_franquia]].sort((a, b) =>
                                                        a.data_registro.localeCompare(b.data_registro)
                                                    );
                                                    const primeiro = registros[0];
                                                    const ultimo = registros[registros.length - 1];
                                                    const mes = ultimo.data_registro.substring(3, 10);
                                                    const crescimento = ultimo.seguidores - primeiro.seguidores;

                                                    return { id_franquia, primeiro, ultimo, mes, crescimento };
                                                })
                                                .sort((a, b) => b.crescimento - a.crescimento)
                                                .map(({ id_franquia, primeiro, ultimo, mes }) => (
                                                    <tr key={id_franquia}>
                                                        <td>{ultimo.nome_franquia}</td>
                                                        <td>{mes}</td>
                                                        <td>{ultimo.seguidores - primeiro.seguidores}</td>
                                                        <td>{ultimo.seguindo - primeiro.seguindo}</td>
                                                        <td>{ultimo.reels - primeiro.reels}</td>
                                                        <td>{ultimo.postagens - primeiro.postagens}</td>
                                                        <td>{ultimo.stories - primeiro.stories}</td>
                                                        <td>{ultimo.visualizacoes - primeiro.visualizacoes}</td>
                                                        <td>{ultimo.curtidas - primeiro.curtidas}</td>
                                                        <td>
                                                            <span className={`badge ${ultimo.status_atual === 'Em dia' ? 'bg-success' :
                                                                    ultimo.status_atual === 'Atenção' ? 'bg-warning text-dark' :
                                                                        'bg-danger'
                                                                }`}>
                                                                {ultimo.status_atual}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ));
                                        })()}
                                    </tbody>
                                </table>
                                <GraficoResumo dados={dados} />
                            </div>

                            <div className="ig-modal-footer">
                                <button className="ig-btn-cancel" onClick={() => setModalResumo(false)}>Fechar</button>
                            </div>
                        </div>
                    </div>
                )}
            </>
        }
    </>
}
export default FranquiasInstagramGeral;